export const DECOR_ICONS = {
  green: 'https://thyaga0323.sirv.com/Images/other/iconGreen.webp',
  orange: 'https://thyaga0323.sirv.com/Images/other/iconOrange.webp',
  starThree: 'https://thyaga0323.sirv.com/Images/other/iconStarThree.webp',
  starTwo: 'https://thyaga0323.sirv.com/Images/other/iconStarTwo.webp',
  underline: 'https://thyaga0323.sirv.com/Images/other/underLine.webp',
};

export const OCCASION_GREETINGS = {
  birthday: 'Happy Birthday',
  anniversary: 'Happy Anniversary',
  wedding: 'Congratulations',
  engagement: 'Congratulations',
  graduation: 'Congratulations',
  congratulations: 'Congratulations',
  'thank you': 'Thank You',
  thanks: 'Thank You',
  'get well soon': 'Get Well Soon',
  'get well': 'Get Well Soon',
  'new year': 'Happy New Year',
  christmas: 'Merry Christmas',
  valentine: "Happy Valentine's Day",
  "valentine's day": "Happy Valentine's Day",
  "mother's day": "Happy Mother's Day",
  "father's day": "Happy Father's Day",
  retirement: 'Happy Retirement',
  housewarming: 'Happy Housewarming',
  'baby shower': 'Congratulations',
  farewell: 'Farewell',
};
